import * as actionTypes from '../constants/actionTypes';
import * as editorNames from '../constants/editorNames';
import * as actions from '../actions';
import { getApiConfig } from '../utilities';
import { hashHistory } from 'react-router';
import _ from 'lodash';
import customEvent from "../utilities/customEvent";

const initialState = {
};
window.editorStoreTimeout = null;

const getCleanState = function () {
  return {
    transientUpdates: 0,
    updatedItems: {},
    updatedTypes: {}
  }
};

function getItemKey(item) {
  if (typeof item === String || typeof item === Number) {
    return item;
  }

  const itemKey = item.id || item.name;
  if (itemKey) {
    return itemKey;
  }

  throw new Error('Cannot determine item key');
}

function getUpdateIds(state, editorName, id) {
  switch (editorName) {
    case editorNames.STONE_SETUP:
    case editorNames.INSTALLATION_GROUP:
    case editorNames.INSTALLATION_CREATOR:
    case editorNames.PROJECT_SCOPE_SETUP:
      return id;
    case editorNames.FABRICATOR_PROFILE:
      return [{ 'id': id }];
    case editorNames.FEATURE_CREATOR:
      var feature = _.find(state.projectScope.features, (feature) => {
        return feature.id == id;
      });
      if(feature) {
        let fid = feature.id;

        if(!feature.fabricatorData) {
          let backingFabFeature = _.first(feature.backingFeatures.filter(f => f.fabricatorData));
          if(backingFabFeature) {
            fid = backingFabFeature.id;
          }
        }
        return fid;
      }
      /*
      var features = _.unionBy(state.features.transientFeatures, state.features.masterFeatures, 'id');
      var featureGroupFeatures = _.filter(features, (feature) => {
        return feature.groupName === featureGroupName;
      });
      return _.map(featureGroupFeatures, function (feature) {
        return { 'id': feature.id };
      });
      */
  }
  return [];
}

function storeTransientUpdates(state, auth) {
  localStorage.setItem(`pending-updates-${auth.fabricatorId}`, JSON.stringify({
    state
  }));
}

function clearStoredTransientUpdates(auth) {
  localStorage.removeItem(`pending-updates-${auth.fabricatorId}`);
}

function hasTransientUpdate(auth) {
  var updateCount = 0;
  var updateData = localStorage.getItem(`pending-updates-${auth.fabricatorId}`);
  if (updateData) {
    try {
      var data = JSON.parse(updateData);
      if (data.state.transientUpdates > 0) {
        return true;
      }
    } catch (ex) {
      console.log(ex);
    }
  }
  return false;
}

function importTransientUpdates(state, auth) {
  if (hasTransientUpdate(auth)) {
    state = getStoredTransientUpdates(state, auth);
  }
  return state;
}

function getStoredTransientUpdates(state, auth) {
  const { transientUpdates, updateItems, updateTypes, ...rest } = state;
  var updateData = localStorage.getItem(`pending-updates-${auth.fabricatorId}`);
  var updates = getCleanState();
  if (updateData) {
    try {
      updates = JSON.parse(updateData);
    } catch (ex) {
      console.log(ex);
    }
  }
  return { ...rest, ...updates.state, firstLoad: false };
}

function _updatetransientField(state, editorName, item, key, value, additionalValueData) {
  const updatedItems = state.updatedItems || {};
  const updatedTypes = state.updatedTypes || {};
  const itemKey = getItemKey(item);
  let updated = updatedItems[itemKey];
  let persistantUpdated = updatedTypes[editorName];
  if (!persistantUpdated) {
    persistantUpdated = updatedTypes[editorName] = {};
  }
  persistantUpdated = updatedTypes[editorName][itemKey];
  if (!updated) {
    updated = updatedItems[itemKey] = {};
  }
  if (!persistantUpdated) {
    persistantUpdated = updatedTypes[editorName][itemKey] = {};
  }

  if(key === 'setAsMaster' && value === false) {
    delete updatedItems[itemKey];
    delete updatedTypes[editorName][itemKey];
    const transientUpdates = (state.transientUpdates || 1) - 1;
    return {...state, transientUpdates, updatedItems, updatedTypes};
  }

  updated[key] = value;
  updated['addData'] = additionalValueData;
  // console.log(111, key, value, updated);
  persistantUpdated[key] = value;
  persistantUpdated['addData'] = additionalValueData;
  const transientUpdates = (state.transientUpdates || 0) + 1;
  return { ...state, transientUpdates, updatedItems, updatedTypes };
}

function updateTransientField(state, { payload: { editorName, item, key, value, additionalValueData } }) {
  return _updatetransientField(state, editorName, item, key, value, additionalValueData);
}

export default function editorReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOAD_EDITOR:
      { //provide unique scope for const variables
        const { updatedItems, ...rest } = state;
        rest['updatedTypes'] = rest['updatedTypes'] || {};
        rest['updatedItems'] = rest.updatedTypes[action.payload.name];
        return { ...rest, name: action.payload.name };
      }
    case actionTypes.LOAD_STORED_TRANSIENT_UPDATES:
      return importTransientUpdates(state, action.payload.auth);

    case actionTypes.UNLOAD_EDITOR:
      return state;

    case actionTypes.UPDATE_TRANSIENT_FIELD: {
      if (action.error) {
        const error = action.payload;
        throw error;
      }

      let newState = updateTransientField(state, action);
      if (window.editorStoreTimeout) {
        window.clearTimeout(window.editorStoreTimeout);
        window.editorStoreTimeout = null;
      }
      window.editorStoreTimeout = window.setTimeout(() => {
        storeTransientUpdates(newState, action.payload.auth);
      }, 500);
      return newState;
    }
    case actionTypes.UPDATE_TRANSIENT_FIELDS: {
      if (action.error) {
        const error = action.payload;
        throw error;
      }
      let newState = state;
      for (var fieldIndex in action.payload.fields) {
        newState = _updatetransientField(newState, action.payload.editorName, action.payload.fields[fieldIndex], action.payload.key, action.payload.value);
      }
      if (window.editorStoreTimeout) {
        window.clearTimeout(window.editorStoreTimeout);
        window.editorStoreTimeout = null;
      }
      window.editorStoreTimeout = window.setTimeout(() => {
        storeTransientUpdates(newState, action.payload.auth);
      }, 500);
      if (action.resolve) {
        action.resolve();
      }
      return newState;
    }

    case actionTypes.CLEAR_TRANSIENT_UPDATES: { //provide unique scope for const variables
        console.log('clearing transient updates');
        const { updatedItems, updatedTypes, transientUpdates, ...rest } = state;
        let newState = action.payload.keepChanges
          ? {...state}
          : { ...rest, updatedItems: {}, updatedTypes: {}, transientUpdates: 0 };
        clearStoredTransientUpdates(action.payload.auth);
        if (action.payload && action.payload.callback)
          action.payload.callback();

        if(!action.payload.saving)
          document.dispatchEvent(customEvent("transientUpdatesCleared"));
        return newState;
      }
    case actionTypes.SAVE_TRANSIENT_UPDATES: {
        const save_data = [];
        _.forOwn(state.updatedTypes, (val, key) => {
          const keyData = [];
          _.forOwn(val, (v, k) => {
            const ids = getUpdateIds(action.payload.state, key, k);
            for(const val in v) {
              if(typeof(v[val]) == "object" && v[val] !== null) {
                v[val] = JSON.stringify(v[val]);
              }
            }
            keyData.push({
              [(typeof ids === 'string' || typeof ids === 'number' ? 'id' : 'ids')]: ids,
              values: v
            });
          });
          save_data.push({
            data_type: key,
            data: keyData
          });
        });
        const api = getApiConfig('dashboard');
        const {asCustomer, auth} = action.payload;
        let fabricator_id = asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
        document.dispatchEvent(customEvent('pre-save-transient'));
        api.post({ fabricator_id, master_fabricator_id: auth.masterFabricatorId, model: save_data }, 'save')
          .then((response) => {
            if (action.payload.callback) {
              action.payload.callback(response);
            }
            window.setTimeout(() => document.dispatchEvent(customEvent('post-save-transient')), 100);
          });
        return state;
      }
    default:
      return state;
  }
}
